import React, { useEffect, useState } from "react";
import { 
  Button, 
  Input, 
  Textarea, 
  Select, 
  SelectItem,
  Card,
  CardBody,
  Chip,
  Divider
} from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faGlobe, faCalendar, faIndustry, faMapMarkerAlt, faLink } from "@fortawesome/free-solid-svg-icons";
import { getAlldata, UpdateSingleCollectionData } from "../../controllers/APIController";
// import { logAuditEvent } from "../../utils/auditLogger";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const Organization = () => {
  const Navigate = useNavigate();
  const [ValidationConditions, setValidationConditions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [allSectorName, setAllSectorName] = useState([]);
   const queryClient = useQueryClient();
  
  const [formData, setFormData] = useState({
    Name: "",
    URL: "",
    Address: "",
    City: "",
    Postal: "",
    "Financial Year": "",
    "Financial Name": "",
    "Start Date": "",
    "End Date": "",
    "Choose Your Region": "",
    "Choose Industry Sector": "",
    Country: "",
    Phone: "",
    Website: "",
    Description: "",
    EmployeeCount: "",
    Revenue: "",
    Industry: "",
    Founded: "",
    TaxID: "",
    RegistrationNumber: "",
    // BRSR Fields
    "Corporate Identity Number": "",
    "Listed Entity Name": "",
    "Year of Incorporation": "",
    "Registered Office Address": "",
    "Corporate Address": "",
    "Email": "",
    "Telephone": "",
    "Stock Exchange": "",
    "Paid-up Capital": "",
    "BRSR Contact Person": "",
    "BRSR Contact Phone": "",
    "BRSR Contact Email": "",
    "Reporting Boundary": "",
    "Assurance Provider": "",
    "Assurance Type": "",
  });

  const [FormDataError, setFormDataError] = useState({
    NameError: "",
    AddressError: "",
    CityError: "",
    PostalError: "",
    "Financial YearError": "",
    "Financial NameError": "",
    "Start DateError": "",
    "End DateError": "",
    "Choose Your RegionError": "",
    "Choose Industry SectorError": "",
    CountryError: "",
    PhoneError: "",
    WebsiteError: "",
    DescriptionError: "",
    EmployeeCountError: "",
    RevenueError: "",
    IndustryError: "",
    FoundedError: "",
    TaxIDError: "",
    RegistrationNumberError: "",
    // BRSR Fields Errors
    "Corporate Identity NumberError": "",
    "Listed Entity NameError": "",
    "Year of IncorporationError": "",
    "Registered Office AddressError": "",
    "Corporate AddressError": "",
    "EmailError": "",
    "TelephoneError": "",
    "Stock ExchangeError": "",
    "Paid-up CapitalError": "",
    "BRSR Contact PersonError": "",
    "BRSR Contact PhoneError": "",
    "BRSR Contact EmailError": "",
    "Reporting BoundaryError": "",
    "Assurance ProviderError": "",
    "Assurance TypeError": "",
  });

  const CollectionName = "organizations";

  // Region options
  const regionOptions = [
    { key: "us-east", name: "US East" },
    { key: "us-west", name: "US West" },
    { key: "us-north", name: "US North" },
    { key: "us-south", name: "US South" },
    { key: "europe", name: "Europe" },
    { key: "asia-pacific", name: "Asia Pacific" },
    { key: "middle-east", name: "Middle East" },
    { key: "africa", name: "Africa" },
    { key: "latin-america", name: "Latin America" }
  ];

  // Industry options
  const industryOptions = [
    { key: "technology", name: "Technology" },
    { key: "healthcare", name: "Healthcare" },
    { key: "finance", name: "Finance" },
    { key: "manufacturing", name: "Manufacturing" },
    { key: "retail", name: "Retail" },
    { key: "energy", name: "Energy" },
    { key: "transportation", name: "Transportation" },
    { key: "construction", name: "Construction" },
    { key: "agriculture", name: "Agriculture" },
    { key: "education", name: "Education" },
    { key: "government", name: "Government" },
    { key: "non-profit", name: "Non-Profit" },
    { key: "other", name: "Other" }
  ];

  // useEffect(() => {
  //   getAlldata(CollectionName)
  //     .then((data) => {
  //       if (data.data !== null) {
  //         setFormData(prev => ({
  //           ...prev,
  //           ...data.data.attributes
  //         }));
  //       }
  //     })
  //     .catch((err) => console.log("error", err));

  //   // Load sectors
  //   getAlldata("sectors")
  //     .then((data) => {
  //       const list = data?.data;
  //       const valuesList = list?.map((item) => ({
  //         key: item?.attributes?.Name?.toLowerCase(),
  //         name: item?.attributes?.Name,
  //       }));
  //       setAllSectorName(valuesList || []);
  //     })
  //     .catch((err) => console.log(err));
  // }, [CollectionName]);


      const { data: orgData } = useQuery({
        queryKey: [CollectionName],
        queryFn: () => getAlldata(CollectionName),
      });

      const { data: sectorData } = useQuery({
        queryKey: ["sectors"],
        queryFn: () => getAlldata("sectors"),
      });

      useEffect(() => {
        if (orgData?.data !== null) {
          setFormData((prev) => ({
            ...prev,
            ...orgData?.data?.attributes,
          }));
        }
        if (sectorData?.data) {
          const list = sectorData?.data;
          const valuesList1 = list?.map((item) => ({
            key: item?.attributes?.Name?.toLowerCase(),
            name: item?.attributes?.Name,
          }));
          setAllSectorName(valuesList1 || []);
          // console.log("Sector List", valuesList1);
        }
      }, [orgData, sectorData]);

  const Validation = () => {
    let isValid = true;
    const errors = {};

    // Required fields validation
    const requiredFields = [
      "Name", "Address", "City", "Postal", "Financial Year", 
      "Financial Name", "Start Date", "End Date", "Choose Your Region", 
      "Choose Industry Sector"
    ];

    requiredFields.forEach(field => {
      if (!formData[field] || !formData[field].trim()) {
      isValid = false;
        errors[`${field}Error`] = `${field.replace(/([A-Z])/g, ' $1').trim()} is required.`;
    } else {
        errors[`${field}Error`] = "";
    }
    });

    // URL validation
    if (formData.Website && !isValidUrl(formData.Website)) {
      isValid = false;
      errors.WebsiteError = "Please enter a valid website URL.";
    }

    // Email validation for contact
    if (formData.Phone && !isValidPhone(formData.Phone)) {
      isValid = false;
      errors.PhoneError = "Please enter a valid phone number.";
    }

    setFormDataError(errors);
    return isValid;
  };

  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  const isValidPhone = (phone) => {
    const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
    return phoneRegex.test(phone.replace(/[\s\-\(\)]/g, ''));
  };

  const SaveChangesHandler = async () => {
    const isValid = Validation();

    if (isValid) {
      setIsLoading(true);
      setValidationConditions(false);
      
      try {
        // Log organization update for audit
        // try {
        //   await logAuditEvent('ORGANIZATION_UPDATED', `Organization: ${formData.Name}`, {
        //     organizationId: formData.id,
        //     updatedFields: Object.keys(formData).filter(key => formData[key]),
        //     organizationName: formData.Name
        //   });
        // } catch (error) {
        //   console.error("Error logging organization update:", error);
        // }

      const response = await UpdateSingleCollectionData("organizations", formData);
        queryClient.invalidateQueries({
          queryKey: [CollectionName]
        });
        queryClient.invalidateQueries({
          queryKey: ["sectors"],
        });
        console.log("Organization updated successfully:", response);
        
        // Show success feedback
        setValidationConditions(false);
      } catch (error) {
        console.error("Error updating organization:", error);
        setValidationConditions(true);
      } finally {
        setIsLoading(false);
      }
    } else {
      setValidationConditions(true);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200">
        <div className="flex items-center gap-2 mb-2">
          <FontAwesomeIcon icon={faBuilding} className="text-emerald-600 text-lg" />
          <h3 className="text-base font-semibold text-slate-900">Organization Information</h3>
          <Chip color="success" variant="flat" size="sm">Active</Chip>
        </div>
        <p className="text-sm text-slate-600 leading-relaxed">
          Modify and manage your organization information, approval process, and reporting standards. 
          Keep your organization details up to date for accurate ESG reporting.
        </p>
      </div>

      {/* Basic Information */}
      <Card className="border border-slate-200 shadow-sm">
        <CardBody className="p-4">
          <div className="flex items-center gap-2 mb-4">
            <FontAwesomeIcon icon={faBuilding} className="text-emerald-600 text-sm" />
            <h4 className="text-base font-semibold text-slate-900">Basic Information</h4>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Organization Name *
              </label>
          <Input
                placeholder="Enter your organization name"
            value={formData.Name}
            onChange={(e) => setFormData({ ...formData, Name: e.target.value })}
                isInvalid={ValidationConditions && !formData.Name}
                errorMessage={FormDataError.NameError}
                startContent={<FontAwesomeIcon icon={faBuilding} className="text-slate-400 text-xs" />}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Organization URL
              </label>
              <Input
                placeholder="your-organization"
                value={formData.URL}
                onChange={(e) => setFormData({ ...formData, URL: e.target.value })}
                startContent={
                  <div className="pointer-events-none flex items-center">
                    <span className="text-default-400 text-xs">
                      {`${process.env.REACT_APP_IP_ADDRESS}/`}
                    </span>
                  </div>
                }
                description="This will be your organization's unique URL"
                size="sm"
              />
            </div>

                        <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Website
              </label>
              <Input
                placeholder="https://www.yourcompany.com"
                value={formData.Website}
                onChange={(e) => setFormData({ ...formData, Website: e.target.value })}
                isInvalid={ValidationConditions && FormDataError.WebsiteError}
                errorMessage={FormDataError.WebsiteError}
                startContent={<FontAwesomeIcon icon={faLink} className="text-slate-400 text-xs" />}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Phone Number
              </label>
              <Input
                placeholder="+1 (555) 123-4567"
                value={formData.Phone}
                onChange={(e) => setFormData({ ...formData, Phone: e.target.value })}
                isInvalid={ValidationConditions && FormDataError.PhoneError}
                errorMessage={FormDataError.PhoneError}
                size="sm"
              />
            </div>

            <div className="md:col-span-2">
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Description
              </label>
              <Textarea
                placeholder="Brief description of your organization..."
                value={formData.Description}
                onChange={(e) => setFormData({ ...formData, Description: e.target.value })}
                minRows={2}
                size="sm"
          />
        </div>
          </div>
        </CardBody>
      </Card>

      {/* Address Information */}
      <Card className="border border-slate-200 shadow-sm">
        <CardBody className="p-4">
          <div className="flex items-center gap-2 mb-4">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-emerald-600 text-sm" />
            <h4 className="text-base font-semibold text-slate-900">Address Information</h4>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="md:col-span-2">
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Address *
              </label>
          <Textarea
                placeholder="Enter your complete address"
            value={formData.Address}
                onChange={(e) => setFormData({ ...formData, Address: e.target.value })}
                isInvalid={ValidationConditions && !formData.Address}
                errorMessage={FormDataError.AddressError}
                minRows={2}
                size="sm"
          />
        </div>

                        <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                City *
              </label>
          <Input
                placeholder="Enter city"
            value={formData.City}
            onChange={(e) => setFormData({ ...formData, City: e.target.value })}
                isInvalid={ValidationConditions && !formData.City}
                errorMessage={FormDataError.CityError}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Postal Code *
              </label>
          <Input
                placeholder="Enter postal code"
            value={formData.Postal}
                onChange={(e) => setFormData({ ...formData, Postal: e.target.value })}
                isInvalid={ValidationConditions && !formData.Postal}
                errorMessage={FormDataError.PostalError}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Country
              </label>
              <Input
                placeholder="Enter country"
                value={formData.Country}
                onChange={(e) => setFormData({ ...formData, Country: e.target.value })}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Region *
              </label>
              <Select
                placeholder="Select your region"
                value={formData["Choose Your Region"]}
                onChange={(e) => setFormData({ ...formData, "Choose Your Region": e.target.value })}
                isInvalid={ValidationConditions && !formData["Choose Your Region"]}
                errorMessage={FormDataError["Choose Your RegionError"]}
                startContent={<FontAwesomeIcon icon={faGlobe} className="text-slate-400 text-xs" />}
                size="sm"
              >
                {regionOptions.map((region) => (
                  <SelectItem key={region.key} value={region.key}>
                    {region.name}
                  </SelectItem>
                ))}
              </Select>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Financial Information */}
      <Card className="border border-slate-200 shadow-sm">
        <CardBody className="p-4">
          <div className="flex items-center gap-2 mb-4">
            <FontAwesomeIcon icon={faCalendar} className="text-emerald-600 text-sm" />
            <h4 className="text-base font-semibold text-slate-900">Financial Information</h4>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Financial Year *
              </label>
              <Input
                placeholder="e.g., 2024"
                value={formData["Financial Year"]}
                onChange={(e) => setFormData({ ...formData, "Financial Year": e.target.value })}
                isInvalid={ValidationConditions && !formData["Financial Year"]}
                errorMessage={FormDataError["Financial YearError"]}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Financial Year Name *
              </label>
              <Input
                placeholder="e.g., FY 2024"
                value={formData["Financial Name"]}
                onChange={(e) => setFormData({ ...formData, "Financial Name": e.target.value })}
                isInvalid={ValidationConditions && !formData["Financial Name"]}
                errorMessage={FormDataError["Financial NameError"]}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Start Date *
              </label>
              <Input
                type="date"
                value={formData["Start Date"]}
                onChange={(e) => setFormData({ ...formData, "Start Date": e.target.value })}
                isInvalid={ValidationConditions && !formData["Start Date"]}
                errorMessage={FormDataError["Start DateError"]}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                End Date *
              </label>
              <Input
                type="date"
                value={formData["End Date"]}
                onChange={(e) => setFormData({ ...formData, "End Date": e.target.value })}
                isInvalid={ValidationConditions && !formData["End Date"]}
                errorMessage={FormDataError["End DateError"]}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Tax ID
              </label>
              <Input
                placeholder="Enter tax identification number"
                value={formData.TaxID}
                onChange={(e) => setFormData({ ...formData, TaxID: e.target.value })}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Registration Number
              </label>
              <Input
                placeholder="Enter business registration number"
                value={formData.RegistrationNumber}
                onChange={(e) => setFormData({ ...formData, RegistrationNumber: e.target.value })}
                size="sm"
              />
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Business Information */}
      <Card className="border border-slate-200 shadow-sm">
        <CardBody className="p-4">
          <div className="flex items-center gap-2 mb-4">
            <FontAwesomeIcon icon={faIndustry} className="text-emerald-600 text-sm" />
            <h4 className="text-base font-semibold text-slate-900">Business Information</h4>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Industry Sector *
              </label>
              <Select
                placeholder="Select your industry sector"
                value={formData["Choose Industry Sector"]}
                onChange={(e) => setFormData({ ...formData, "Choose Industry Sector": e.target.value })}
                isInvalid={ValidationConditions && !formData["Choose Industry Sector"]}
                errorMessage={FormDataError["Choose Industry SectorError"]}
                startContent={<FontAwesomeIcon icon={faIndustry} className="text-slate-400 text-xs" />}
                size="sm"
              >
                {allSectorName.map((sector) => (
                  <SelectItem key={sector.key} value={sector.key}>
                    {sector.name}
                  </SelectItem>
                ))}
              </Select>
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Industry
              </label>
              <Select
                placeholder="Select industry"
                value={formData.Industry}
                onChange={(e) => setFormData({ ...formData, Industry: e.target.value })}
                size="sm"
              >
                {industryOptions.map((industry) => (
                  <SelectItem key={industry.key} value={industry.key}>
                    {industry.name}
                  </SelectItem>
                ))}
              </Select>
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Employee Count
              </label>
              <Input
                placeholder="e.g., 1000"
                value={formData.EmployeeCount}
                onChange={(e) => setFormData({ ...formData, EmployeeCount: e.target.value })}
                type="number"
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Annual Revenue
              </label>
              <Input
                placeholder="e.g., $10,000,000"
                value={formData.Revenue}
                onChange={(e) => setFormData({ ...formData, Revenue: e.target.value })}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Founded Year
              </label>
              <Input
                placeholder="e.g., 1995"
                value={formData.Founded}
                onChange={(e) => setFormData({ ...formData, Founded: e.target.value })}
                type="number"
                min="1800"
                max={new Date().getFullYear()}
                size="sm"
          />
        </div>
      </div>
        </CardBody>
      </Card>

      {/* BRSR Information */}
      <Card className="border border-slate-200 shadow-sm">
        <CardBody className="p-4">
          <div className="flex items-center gap-2 mb-4">
            <FontAwesomeIcon icon={faBuilding} className="text-emerald-600 text-sm" />
            <h4 className="text-base font-semibold text-slate-900">BRSR Information</h4>
            <Chip color="warning" variant="flat" size="sm">BRSR Compliance</Chip>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Corporate Identity Number (CIN)
              </label>
              <Input
                placeholder="Enter CIN of the Listed Entity"
                value={formData["Corporate Identity Number"]}
                onChange={(e) => setFormData({ ...formData, "Corporate Identity Number": e.target.value })}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Listed Entity Name
              </label>
              <Input
                placeholder="Enter name of the Listed Entity"
                value={formData["Listed Entity Name"]}
                onChange={(e) => setFormData({ ...formData, "Listed Entity Name": e.target.value })}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Year of Incorporation
              </label>
              <Input
                placeholder="e.g., 1995"
                value={formData["Year of Incorporation"]}
                onChange={(e) => setFormData({ ...formData, "Year of Incorporation": e.target.value })}
                type="number"
                min="1800"
                max={new Date().getFullYear()}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Stock Exchange
              </label>
              <Input
                placeholder="e.g., NSE, BSE"
                value={formData["Stock Exchange"]}
                onChange={(e) => setFormData({ ...formData, "Stock Exchange": e.target.value })}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Paid-up Capital
              </label>
              <Input
                placeholder="e.g., ₹100,000,000"
                value={formData["Paid-up Capital"]}
                onChange={(e) => setFormData({ ...formData, "Paid-up Capital": e.target.value })}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Reporting Boundary
              </label>
              <Select
                placeholder="Select reporting boundary"
                value={formData["Reporting Boundary"]}
                onChange={(e) => setFormData({ ...formData, "Reporting Boundary": e.target.value })}
                size="sm"
              >
                <SelectItem key="standalone" value="standalone">
                  Standalone basis (only for the entity)
                </SelectItem>
                <SelectItem key="consolidated" value="consolidated">
                  Consolidated basis (entity and all subsidiaries)
                </SelectItem>
              </Select>
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Assurance Provider
              </label>
              <Input
                placeholder="Enter name of assurance provider"
                value={formData["Assurance Provider"]}
                onChange={(e) => setFormData({ ...formData, "Assurance Provider": e.target.value })}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Assurance Type
              </label>
              <Select
                placeholder="Select type of assurance"
                value={formData["Assurance Type"]}
                onChange={(e) => setFormData({ ...formData, "Assurance Type": e.target.value })}
                size="sm"
              >
                <SelectItem key="limited" value="limited">
                  Limited Assurance
                </SelectItem>
                <SelectItem key="reasonable" value="reasonable">
                  Reasonable Assurance
                </SelectItem>
                <SelectItem key="none" value="none">
                  No Assurance
                </SelectItem>
              </Select>
            </div>
          </div>

          <Divider className="my-4" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Registered Office Address
              </label>
              <Textarea
                placeholder="Enter registered office address"
                value={formData["Registered Office Address"]}
                onChange={(e) => setFormData({ ...formData, "Registered Office Address": e.target.value })}
                size="sm"
                minRows={2}
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Corporate Address
              </label>
              <Textarea
                placeholder="Enter corporate address"
                value={formData["Corporate Address"]}
                onChange={(e) => setFormData({ ...formData, "Corporate Address": e.target.value })}
                size="sm"
                minRows={2}
              />
            </div>
          </div>

          <Divider className="my-4" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Email
              </label>
              <Input
                placeholder="Enter email address"
                value={formData["Email"]}
                onChange={(e) => setFormData({ ...formData, "Email": e.target.value })}
                type="email"
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Telephone
              </label>
              <Input
                placeholder="Enter telephone number"
                value={formData["Telephone"]}
                onChange={(e) => setFormData({ ...formData, "Telephone": e.target.value })}
                type="tel"
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                Website
              </label>
              <Input
                placeholder="https://www.yourcompany.com"
                value={formData["Website"]}
                onChange={(e) => setFormData({ ...formData, "Website": e.target.value })}
                type="url"
                size="sm"
              />
            </div>
          </div>

          <Divider className="my-4" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                BRSR Contact Person
              </label>
              <Input
                placeholder="Enter name of BRSR contact person"
                value={formData["BRSR Contact Person"]}
                onChange={(e) => setFormData({ ...formData, "BRSR Contact Person": e.target.value })}
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                BRSR Contact Phone
              </label>
              <Input
                placeholder="Enter BRSR contact phone number"
                value={formData["BRSR Contact Phone"]}
                onChange={(e) => setFormData({ ...formData, "BRSR Contact Phone": e.target.value })}
                type="tel"
                size="sm"
              />
            </div>

            <div>
              <label className="text-xs font-medium text-slate-700 mb-1 block">
                BRSR Contact Email
              </label>
              <Input
                placeholder="Enter BRSR contact email address"
                value={formData["BRSR Contact Email"]}
                onChange={(e) => setFormData({ ...formData, "BRSR Contact Email": e.target.value })}
                type="email"
                size="sm"
              />
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Save Button */}
      <div className="flex justify-center pt-4">
        <Button
          color="primary"
          className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 font-medium text-sm"
          onClick={SaveChangesHandler}
          isLoading={isLoading}
          size="sm"
        >
          {isLoading ? "Saving Changes..." : "Save Changes"}
        </Button>
      </div>
    </div>
  );
};

export default Organization;
